var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b55f8d61f36ad431affb979403815ebcb5e02d71"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-headlinker@martinratinaud"]={id:"b55f8d61f36ad431affb979403815ebcb5e02d71"};
      